export const environment = {
  production: false,
  apiUrl: 'https://stagapi.archoftraits.com',
  websocketUrl: 'wss://stagapi.archoftraits.com',
  version: '2.5.1',
  stripe_public_key: 'pk_test_51THN3c2RwDbYXxpxok5DxvcqUe9NeqMMCR9cyHhinyJ4aHuBpZ9jYdnalXEAfDxlyLukXlQm83WNNDfJm6RSYfGI00DXV4K3k8'
};
